import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBareMetal = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-bare-metal';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M8.26 4.241 4.108 6.582l-.472.265.162.294c.089.163.162.314.162.337 0 .026-.136.042-.36.042h-.36l.001 4.71.001 4.71 4.162 2.34a1005 1005 0 0 0 4.197 2.353c.019.007.112-.124.207-.29s.181-.302.192-.302.098.136.192.302c.095.166.188.297.207.29s1.908-1.066 4.197-2.353l4.162-2.34V12l-.001-4.94-4.344-2.44c-2.389-1.342-4.373-2.443-4.409-2.447s-1.72.926-3.744 2.068m7.395 1.676 3.585 2.018v8.135l-3.23 1.817-3.23 1.817-.02-4.073-.02-4.072-3.572-2.01C7.203 8.444 5.595 7.524 5.594 7.503c-.002-.051 6.332-3.619 6.411-3.61.035.004 1.678.915 3.65 2.024M6.311 9.66l.927.52.011 2.258.011 2.258 1.99 1.12 1.99 1.119v2.78l-.565-.318-3.24-1.822-2.675-1.504V8.795l.312.173c.172.094.729.406 1.239.692m9.402 1.594a178 178 0 0 0-2.053 1.192c-.03.031.699 1.319.735 1.298l3.991-2.291.167-.096-.365-.639c-.201-.351-.384-.637-.406-.635s-.954.529-2.069 1.171m-5.513.596 1.02.574.011 1.391c.005.766-.005 1.386-.024 1.379-.018-.008-.576-.32-1.24-.694l-1.207-.68v-2.781l.21.119zm5.549 2.806a106 106 0 0 0-2.071 1.21q-.038.041.305.637c.189.328.359.613.377.632.036.038 4.117-2.285 4.147-2.361.018-.044-.667-1.294-.707-1.289-.011.001-.934.528-2.051 1.171"
    })
  }));
});
export default SvgBareMetal;